import React, { useEffect, useState } from "react";
import bg from '../assets/images/LMS-bg.jpg'
import Spinner from './spinner/spinner'
const LMS_API_URL = process.env.REACT_APP_LMS_API_URL;
const LMS_ID = process.env.REACT_APP_LMS_ID;


const SampleModuleOffsession = () => {
    const [sessions, setSessions] = useState("");
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                // Step 1: Get all session image data
                const res = await fetch(LMS_API_URL + "offSession/getImageDataByModuleId/" + LMS_ID);
                const data = await res.json();
                setLoading(false)
                // Step 2: For each session, get the presigned URL
                const sessions = await Promise.all(
                    data?.data.map(async (item) => {
                        const imgRes = await fetch(
                            LMS_API_URL + "offSession/aws/getImagePresignedUrl",
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                },
                                body: JSON.stringify({
                                    documentID: item?.documentID,
                                }),
                            }
                        );

                        const imgData = await imgRes.json();
                        const imageUrl = imgData?.data;

                        return { ...item, imageUrl };
                    })
                );
                setSessions(sessions || []);
            } catch (err) {
                setLoading(false)
                setSessions([])
                console.error("Error fetching:", err);
            }
        };

        fetchSessions();
    }, []);

    return (
        loading ? <Spinner /> :
            <div className="container py-4" >
                {/* Header Section */}
                {sessions.length > 0 ?
                    <>
                        <div className="text-center mb-4">
                            <h2 className="fw-bold">Off-session Reading</h2>
                        </div>

                        {/* Card Layout */}

                        <div className="border-0">
                            <div className="py-3 px-md-5 px-3">
                                {sessions?.map(sess => <div className="row mb-5 shadow-lg border rounded-5 p-md-5 p-3" style={{
                                    backgroundImage: `url(${bg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: 'no-repeat'
                                }}>
                                    <div className="col-md-4 d-flex justify-content-center align-items-center">
                                        <img src={sess?.imageUrl} alt="Offsession reading" loading="lazy" width={'100%'} />
                                    </div>
                                    <div className="col-md-8">
                                        <p className="text-capitalize text-center fw-bold">{sess.imageFileName}</p>
                                        {/* Render Dangerous HTML from API */}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: sess.offSessionImageText
                                            }}
                                            className="content-text partner-text-justify fw-bold lh-lg"
                                        ></div>
                                    </div>
                                </div>)}

                            </div>
                        </div></> : <p className="text-center">Will Be Added Shortly</p>}
            </div>
    );
};

export default SampleModuleOffsession
    ;